export default "__VITE_ASSET__cVlvN9gv__"